export class FluxoAprovacoesConfirmModalService {
    static $inject = [
        '$uibModal'
    ];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) { }

    public open(): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./fluxoaprovacoesconfirm.modal.html'),
            controller: 'FluxoAprovacoesConfirmModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
            }
        });
    }
}
